module.exports = __webpack_public_path__ + "static/ui3-ebb45c4effc40ab41271fd2c0a2c0ecb.mp3";